// extracted by mini-css-extract-plugin
export default {"root":"FilterDrawerHeader_root__cMXhN","title":"FilterDrawerHeader_title__mCunz"};